export default "__VITE_ASSET__DAju0P2W__"